/* eslint-disable */
import * as d3 from "d3";

// Shared ramp used by the Steam / Twitch / mindSHARE bubble views.
export const PALETTE = [
  "#ff5342",
  "#fe6d4e",
  "#ff9463",
  "#ffc28b",
  "#819898",
  "#4c7d8e",
  "#174d7c",
  "#2794c3",
];

/**
 * Log colour ramp over the 2nd..98th percentile of member counts. Using the raw
 * min/max lets a single huge server flatten everything into one colour.
 */
export function makeMemberColorScale(servers) {
  const interp = d3.piecewise(d3.interpolateRgb.gamma(2.2), PALETTE);
  const vals = (servers || [])
    .map((s) => Number(s.members) || 0)
    .filter((v) => v > 0)
    .sort(d3.ascending);

  if (!vals.length) return () => PALETTE[0];

  const lo = Math.max(1, d3.quantile(vals, 0.02) ?? vals[0]);
  const hi = Math.max(lo * 10, d3.quantile(vals, 0.98) ?? vals[vals.length - 1]);
  const logT = d3.scaleLog().domain([lo, hi]).range([0, 1]).clamp(true);

  return (members) => {
    const v = Math.max(0, members || 0);
    return v <= 0 ? PALETTE[0] : interp(logT(v));
  };
}

export function computePopoverPos({ x, y, r, containerWidth, containerHeight }) {
  const W = 280;
  const H = 250;
  const gap = 14;
  let left = x + r + gap;
  if (left + W > containerWidth - 8) left = x - r - gap - W;
  left = Math.max(8, Math.min(left, containerWidth - W - 8));
  let top = y - H / 2;
  top = Math.max(8, Math.min(top, containerHeight - H - 8));
  return { left, top, width: W };
}

/** Normalizes an API row into the shape both bubble views render. */
export function toBubbleDatum(s, colorScale) {
  const members = Math.max(0, Number(s.members) || 0);
  return {
    server_id: s.server_id, // snowflake stays a string
    name: s.server_name || "Unknown Server",
    value: members,
    members,
    online: s.online,
    online_pct: s.online_pct,
    boosts: s.boosts,
    verified: s.verified,
    partnered: s.partnered,
    description: s.description,
    icon_url: s.icon_url,
    splash_url: s.splash_url,
    banner_url: s.banner_url,
    discord_url: s.discord_url,
    games: s.games || [],
    color: colorScale(members),
  };
}

export const BUBBLE_LABEL_FONT =
  '"Segoe UI", system-ui, -apple-system, sans-serif';
